module.exports = new __parcel__URL__("bossfight_victory_badge.3b8ee411.png").toString();